<!-- <div style="position:fixed; width:98%; height:33%;" id="Top">
    <div class="row">
        <div class="col-xs-12 col-sm-4 panels">
            <app-ehs-personal-safety                            
                ehs_CurrentYear={{graphData.ehs_CurrentYear}}
                ehs_Injury_Max={{graphData.ehs_Injury_Max}}
                ehs_Injury_Yellow={{graphData.ehs_Injury_Yellow}}
                ehs_Injury_Orange={{graphData.ehs_Injury_Orange}}
                ehs_Injury_CurrentYearValue={{graphData.ehs_Injury_CurrentYearValue}}
                ehs_Injury_LastYearValue={{graphData.ehs_Injury_LastYearValue}}
                ehs_Injury_Text={{graphData.ehs_Injury_Text}}
            >
            </app-ehs-personal-safety>                                      
        </div>
        <div class="col-xs-12 col-sm-4 panels">
            <app-ehs-injury-free-days
                ehs_InjuryDays_TextPerformance={{graphData.ehs_InjuryDays_TextPerformance}}
                ehs_InjuryDays_TextExplanation={{graphData.ehs_InjuryDays_TextExplanation}}
                ehs_InjuryDays_Value={{graphData.ehs_InjuryDays_Value}}
            >
            </app-ehs-injury-free-days>   
        </div>
        <div class="col-xs-12 col-sm-4 panels">
            <app-ehs-process-safety
                ehs_CurrentYear={{graphData.ehs_CurrentYear}}
                ehs_Process_CurrentYearValue={{graphData.ehs_Process_CurrentYearValue}}
                ehs_Process_LastYearValue={{graphData.ehs_Process_LastYearValue}}
                ehs_Process_Text={{graphData.ehs_Process_Text}}
                ehs_Process_Max={{graphData.ehs_Process_Max}}
                ehs_Process_Yellow={{graphData.ehs_Process_Yellow}}
                ehs_Process_Orange={{graphData.ehs_Process_Orange}}
            >
            </app-ehs-process-safety>  
    </div>
    </div>
</div>
<div style="position:fixed; width:97%; height:33%;" id="Middle"></div>
<div style="position:fixed; width:96%; height:33%;" id="Bottom"></div> -->

<div *ngIf="fetchDataFailed" class="panelbar-wrapper ehs-sub-title" style="color:crimson">
    Error fetching Dashboard data
</div>
<div *ngIf="gotTheData" class="panelbar-wrapper">
    <kendo-panelbar>
        <kendo-panelbar-item id="ehs" [title]="'EHS'" expanded="true">
            <ng-template kendoPanelBarContent>
                <div class="row" #ehs id="ehs">
                    <div class="col-xs-12 col-sm-4 panels">
                        <p style="width: 100%; text-align: center; margin: 0px; border-bottom-color:white;">

                            <app-ehs-personal-safety ehs_CurrentYear={{graphData.ehs_CurrentYear}}
                                ehs_Injury_Max={{graphData.ehs_Injury_Max}}
                                ehs_Injury_Yellow={{graphData.ehs_Injury_Yellow}}
                                ehs_Injury_Orange={{graphData.ehs_Injury_Orange}}
                                ehs_Injury_CurrentYearValue={{graphData.ehs_Injury_CurrentYearValue}}
                                ehs_Injury_LastYearValue={{graphData.ehs_Injury_LastYearValue}}
                                ehs_Injury_Text={{graphData.ehs_Injury_Text}}>
                            </app-ehs-personal-safety>
                        </p>
                    </div>

                    <div class="col-xs-12 col-sm-4 panels" style="text-align: center;">
                        <app-ehs-injury-free-days
                            ehs_InjuryDays_TextPerformance={{graphData.ehs_InjuryDays_TextPerformance}}
                            ehs_InjuryDays_TextExplanation={{graphData.ehs_InjuryDays_TextExplanation}}
                            ehs_InjuryDays_Value={{graphData.ehs_InjuryDays_Value}}>
                        </app-ehs-injury-free-days>
                    </div>

                    <div class="col-xs-12 col-sm-4 panels">
                        <app-ehs-process-safety ehs_CurrentYear={{graphData.ehs_CurrentYear}}
                            ehs_Process_CurrentYearValue={{graphData.ehs_Process_CurrentYearValue}}
                            ehs_Process_LastYearValue={{graphData.ehs_Process_LastYearValue}}
                            ehs_Process_Text={{graphData.ehs_Process_Text}}
                            ehs_Process_Max={{graphData.ehs_Process_Max}}
                            ehs_Process_Yellow={{graphData.ehs_Process_Yellow}}
                            ehs_Process_Orange={{graphData.ehs_Process_Orange}}>
                        </app-ehs-process-safety>
                    </div>
                </div>
            </ng-template>
        </kendo-panelbar-item>

        <kendo-panelbar-item id="ops" [title]="'Operational'" expanded="true">
            <ng-template kendoPanelBarContent>
                <div class="row" #ops id="ops">
                    <div class="col-xs-12 col-sm-3 panels">
                        <highcharts-chart *ngIf="opsChart1" [Highcharts]="Highcharts" [options]="opsChart1"></highcharts-chart>
                    </div>
                    <div class="col-xs-12 col-sm-3 panels">
                        <highcharts-chart *ngIf="opsChart2" [Highcharts]="Highcharts" [options]="opsChart2"></highcharts-chart>
                    </div>
                    <div class="col-xs-12 col-sm-3 panels">
                        <highcharts-chart *ngIf="opsChart3" [Highcharts]="Highcharts" [options]="opsChart3"></highcharts-chart>
                    </div>
                    <div class="col-xs-12 col-sm-3 panels">
                        <p x="251" class="highcharts-title"
                            style="text-align:center;color:#333333;font-size:18px;font-family:Verdana;font-weight:normal;font-style:normal;fill:#333333;padding-top:10px;"
                            y="28">
                            <span>Exploration & Drilling Milestones</span>
                        </p>
                        <p style="padding: 0px; width: 100%; text-align: center; margin: 0px; padding: 0px;">
                            <kendo-grid [data]="opsChart4" [style.maxHeight.px]="340" [height]="340" [resizable]="true">
                                <kendo-grid-column field="target" title="Target" width="12px"
                                    [headerStyle]="{'font-size' : '14px', 'padding': '8px 3px'}">
                                    <ng-template kendoGridCellTemplate let-dataItem>
                                        <img src="{{'./assets/images/' + dataItem.target + '.png'}}"
                                            style="padding: 0px;" />
                                    </ng-template>
                                </kendo-grid-column>
                                <kendo-grid-column field="wellName" title="Well Name" width="25%"
                                    [style]="{'font-size': '13px', 'padding': '3px'}"
                                    [headerStyle]="{'font-size' : '14px', 'padding': '8px 3px'}"></kendo-grid-column>
                                <kendo-grid-column field="wellType" title="Well Type" width="22%"
                                    [style]="{'font-size': '13px', 'padding': '3px'}"
                                    [headerStyle]="{'font-size' : '14px', 'padding': '8px 3px'}"></kendo-grid-column>
                                <kendo-grid-column field="basin" title="Basin" width="18%"
                                    [style]="{'font-size': '13px', 'padding': '3px'}"
                                    [headerStyle]="{'font-size' : '14px', 'padding': '8px 3px'}"></kendo-grid-column>
                                <kendo-grid-column field="status" title="Status" width="18%"
                                    [style]="{'font-size': '13px', 'padding': '3px'}"
                                    [headerStyle]="{'font-size' : '14px', 'padding': '8px 3px'}"></kendo-grid-column>
                            </kendo-grid>
                        </p>
                    </div>
                </div>
            </ng-template>
        </kendo-panelbar-item>


        <kendo-panelbar-item [title]="'Financial'" expanded="true">
            <ng-template kendoPanelBarContent>
                <div class="row" #fin id="fin">
                    <div class="col-xs-12 col-sm-3">
                        <highcharts-chart *ngIf="finChart1" [Highcharts]="Highcharts" [options]="finChart1"></highcharts-chart>
                    </div>
                    <div class="col-xs-12 col-sm-3">
                        <highcharts-chart *ngIf="finChart2" [Highcharts]="Highcharts" [options]="finChart2"></highcharts-chart>
                    </div>
                    <div class="col-xs-12 col-sm-3">
                        <highcharts-chart *ngIf="finChart3" [Highcharts]="Highcharts" [options]="finChart3"></highcharts-chart>
                    </div>
                    <div class="col-xs-12 col-sm-3">
                        <highcharts-chart *ngIf="finChart4" [Highcharts]="Highcharts" [options]="finChart4"></highcharts-chart>
                    </div>
                </div>
            </ng-template>
        </kendo-panelbar-item>
    </kendo-panelbar>
    <!-- <div class="row">
        <span class="disclaimer"> 
            <p style="margin-right: 10px; margin-bottom: 0px;">Disclaimer: &emsp;</p>
            <p style="font-style:italic; margin-bottom: 0px;">
                &copy; Unauthorised use of this website may give rise to a claim for damages and/or be a criminal offence.
            </p>
        </span>
    </div> -->
    <div class="row">
        <span class="disclaimer">
            <p style="margin-bottom: 0px;">
                Dashboard updates in line with market disclosure
            </p>
        </span>
    </div>

</div>